/**
 * Do not edit directly
 * Generated on Fri, 11 Apr 2025 00:13:33 GMT
 */
export const darkTheme = {
    color: {
        transparent: 'rgba(0,2,11,0)',
        black: 'rgba(0,2,11,1)',
        white: 'rgba(236,236,240,1)',
        zodiacBlue: 'rgba(24,31,72,1)',
        teal30: 'rgba(97,201,211,0.2)',
        teal100: 'rgba(97,201,211,1)',
        blueGray50: 'rgba(76,84,145,1)',
        blueGray100: 'rgba(24,29,45,1)',
        prussianBlue: 'rgba(36,41,68,1)',
        navyBlue: 'rgba(21,20,40,1)',
        primeBlue: 'rgba(8,12,24,1)',
        red10: 'rgba(255,115,148,0.10196078431372549)',
        red100: 'rgba(255,115,148,1)',
        orange: 'rgba(255,159,121,1)',
        yellow: 'rgba(226,200,133,1)',
        green10: 'rgba(155,226,133,0.10196078431372549)',
        green100: 'rgba(155,226,133,1)',
        purple10: 'rgba(141,94,182,0.10196078431372549)',
        purple80: 'rgba(161,84,228,1)',
        purple100: 'rgba(141,94,182,1)',
        pink20: 'rgba(202,75,160,0.2)',
        pink100: 'rgba(202,75,160,1)',
        blue10: 'rgba(179,224,255,0.10196078431372549)',
        blue100: 'rgba(179,224,255,1)',
        lavender30: 'rgba(135,91,255,0.30196078431372547)',
        lavender100: 'rgba(135,91,255,1)',
        dimRed: 'rgba(24,15,13,1)',
        dimOrange: 'rgba(26,15,9,1)',
        dimYellow: 'rgba(24,20,13,1)',
        dimGreen: 'rgba(15,23,14,1)',
        dimWhite: 'rgba(24,20,17,1)',
        dimBlue: 'rgba(6,23,33,1)',
        dimPurple: 'rgba(15,10,19,1)',
        dimTeal: 'rgba(15,37,40,1)',
        dimBlueGray: 'rgba(17,23,38,1)',
        dimPink: 'rgba(35,12,27,1)',
        dimLavender: 'rgba(23,14,47,1)',
    },
    shadow: {
        topLt: '0px -24px 24px #29292933',
        topMd: '0px -24px 24px #29292966',
        leftMd: '-8px 0px 24px #29292966',
        leftLt: '-8px 0px 24px #29292933',
        rightMd: '8px 0px 24px #29292966',
        rightLt: '8px 0px 24px #29292933',
        md: '0px 4px 8px #29292966',
        lt: '0px 2px 4px #29292933',
    },
    spacing: {
        px4: '4px',
        px8: '8px',
        px12: '12px',
        px16: '16px',
        px24: '24px',
        px32: '32px',
        px40: '40px',
        px48: '48px',
        px64: '64px',
        px80: '80px',
        px96: '96px',
        px160: '160px',
    },
    font: {
        titleH1: {
            font: 'normal 450 28px/42px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
        titleH2: {
            font: 'normal 450 24px/36px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
        titleH3: {
            font: 'normal 450 20px/30px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
        titleH4: {
            font: 'normal 450 18px/27px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
        titleH5: {
            font: 'normal 450 16px/24px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
        titleH6: {
            font: 'normal 450 14px/21px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
        body: {
            font: 'normal 350 16px/27px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
        bodyItalic: {
            font: 'italic 350 16px/27px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
        bodyStrong: {
            font: 'normal 450 16px/27px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
        label: {
            font: 'normal 300 14px/24px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
        labelStrong: {
            font: 'normal 450 14px/24px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
        metadata: {
            font: 'normal 300 12px/14px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
        metadataStrong: {
            font: 'normal 450 12px/14px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
        assistive: {
            font: 'normal 300 14px/21px Inter',
            textTransform: 'none',
            fontOpticalSizing: 'auto',
        },
    },
    zIndex: {
        sunk: -9999,
        default: 1,
        sticky: 100,
        dialog: 1000,
        modal: 4000,
        popover: 2000,
        dropdown: 4500,
        tooltip: 4500,
        toast: 5000,
    },
};
